export const EXPENSE = {
  List: '/expenses',
  Create: '/expenses',
  Detail: '/expenses/{id}',
  Update: '/expenses/{id}',
  Delete: '/expenses/{id}',
  Bulk: '/expenses/bulk',
};
